module.exports = "./img/9faf70292c40b627ca97644674c0771a.jpg";